export class EquipmentTypeFilter {
    startingIndex: number;
    pageSize: number;
    searchKey: string;
      constructor(obj?: EquipmentTypeFilter) {
        if (obj) {
          this.startingIndex = obj.startingIndex;
          this.pageSize = obj.pageSize;
          this.searchKey = obj.searchKey;
        }
      }
}
